import axios from 'axios'
import VueMixinTween from 'vue-mixin-tween';
import {
    Navbar,
    DropDown,
    NavLink
} from '@/components';
import {
    mapState
} from 'vuex'
export default {
    name: 'main-navbar',
    mounted() {
        var w = this;
        setTimeout(() => {
            this.isActive = true;
        }, 500)
        let user = this.$adal.user
        if ( user && user.userName ) {
        this.$adal.acquireToken('6e0cdae3-9345-4b51-aa10-8d00a3512389', async (err, token) => {
        this.$store.commit('change', {
            'apollo-token': token
            })
        this.$store.commit('change', {
            user: {
                username: user.userName
            }
            })
            })
            } else {
        this.$store.commit('change', { user: undefined })
        }
    },
    data() {
        return {
            spinner: false,
            error: false,
            lastSubAttempt: Date.now(),
            isActive: false,
            subscriptions: {},
            credits: this.$store.getters.get('credits'),
            modals: {
                classic: false
            },
            signedIn: false,
            usermail: null,
            to: this.$route && this.$route.query && this.$route.query.to ? this.$route.query.to : false
        }
    },
    computed: {
        ...mapState({
            lastQuery: 'lastQuery',
            cbloaded: 'cbInstance',
            onLine: 'onLine',
            slider: 'slider',
            subId: 'subId',
            statusMessage: 'statusMessage',
            subscription: 'subscription',
            lastUpdate: 'lastUpdate',
            userUpdated: 'userUpdated',
            graphQLurl: 'graphQLurl',
            subsActive: 'subsActive'
        }),
        username: function() { let user = this.$store.getters.get('user'); return ( user && user.username ? user.username : '' ) },
        subscriptionStatus: function() {
            if (this.onLine) {
                this.reconnect()
                return true
            } else {
                this.disconnect()
                return false
            }
        }
    },
    beforeCreate() {
        this.$eventBus.$on('spinner', info => {
            if (info === 'run') {
                this.spinner = true;
            } else {
                this.spinner = false;
            }
        });
        this.$eventBus.$on('authState', info => {
        });
    },
    created() {
        var w = this;
        this.$eventBus.$on('appEvents', info => {
            if (typeof(info) === 'object' && info.component === 'nav') {
                var exec = info.exec;
                try {
                    this[exec](info.params)
                } catch (err) {
                    console.log('error: ', err)
                }
            } else {
                if (typeof(info) === 'object' && info.exec === 'refreshCache') {
                    localStorage.setItem('cacheVer', info.params)
                }
            }
        })
    },
    props: {
        transparent: Boolean,
        colorOnScroll: Number,
    },
    components: {
        Navbar,
        NavLink,
        DropDown
        //GenoLogo
    },
    mixins: [
        VueMixinTween('credits', 100, (pos) => pos)
    ],
    methods: {
        adLogout: function() {
        this.$router.push('/')
        this.$adal.logout()
        this.$store.commit('change', {
            user: undefined
            })
        },
        execDefAction: function(evt) {
            let event = 'navbar-mobile';
            this.$root.$emit(event, 'close');
        },
        adLogin: function() {
        this.$adal.login()
        let user = this.$adal.user
        user.username = user.userName
        this.$store.commit('change', {
            user: user
            })
                    this.$router.push('/')
        },
        setStatusMessage: function(params) {
            if (params.message && params.id && params.id === this.subId) {
                this.$store.commit('change', {
                    fadeIn: false
                });
                this.$store.commit('change', {
                    statusMessage: params.message
                });
                setTimeout(() => {
                    this.$store.commit('change', {
                        fadeIn: true
                    });
                }, 500)
            }
        },
        clearError: function() {
            this.error = false;
        },
        GetFormattedDate: function() {
            var format = function(str) {
                var str = "0" + str;
                var l = str.length;
                return (str.substring(l - 2, l))
            }
            var todayTime = new Date();
            var month = format(todayTime.getMonth() + 0);
            var day = format(todayTime.getDate());
            var year = (todayTime.getFullYear());
            //return month + "/" + day + "/" + year;
            return year + "-" + month + "-" + day;

        },
        show: function(params) {
            var w = this;
            var title = params.title ? params.title : 'Alert!'
            var text = params.text ? params.text : 'Message received...'
            var button = params.button ? params.button : 'OK'
            var buttons = [{
                title: button,
                default: true, // Will be triggered by default if 'Enter' pressed.
            }]
            if (params.closed && params.closed === 'clearError') {
                buttons.unshift({
                    title: 'Clear Error',
                    handler: () => {
                        if (params.closed) w[params.closed]();
                        this.$modal.hide('dialog')
                    } // Button click handler
                })
            }
            if (params.action && typeof(params.action) === 'object' && params.action.button && params.action.method) {
                var action = params.action
                buttons.unshift({
                    title: action.button,
                    handler: () => {
                        this[action.method](action.params)
                    }
                })
            }
            this.$modal.show('dialog', {
                title: title,
                text: text,
                class: params.class ? params.class : undefined,
                buttons: buttons,
                beforeClose: function(event) {
                    console.log('closed ', event)
                }
            })
        },
        refreshPage: function() {
            window.location.reload(true)
        },
        execFunc(remoteFunc) {
            this.$eventBus.$emit('appEvents', remoteFunc)
        },
        getStatus: function() {
            var title = "Current Status"
            var text = ''
            if (this.onLine && this.subsActive) {
                var subs = Object.keys(this.subscriptions);
                text = '<b style="color:green">application is online</b><br/><br/>active channels:<br/><b>'
                subs.forEach(id => {
                    text = text + id + "<br/>"
                })
                text = text + "</b>"
                if (this.lastQuery) {
                    text = text + '<br/>' + this.lastQuery
                }
                if (this.error) {
                    text = text + '<br/><b style="color:brown">Error:</b> ' + this.error
                }
            } else {
                text = '<b style="color:brown" >application is offline</b><br/><br/>disonnected channels:<br/><b>'
                var subs = Object.keys(this.subscriptions);
                subs.forEach(id => {
                    text = text + id + "<br/>"
                })
                text = text + "</b>"
                if (this.lastQuery) {
                    text = text + '<br/>' + this.lastQuery
                }
                if (this.error) {
                    text = text + '<br/><b style="color:brown">Error:</b> ' + this.error
                }
            }
            this.show({
                title: title,
                text: text,
                closed: this.error ? 'clearError' : undefined
            });
        },

        showProfile: function() {
            if (this.$adal.user) {
            }
        },
        signOut: function(event) {
            this.$auth.signOut()
                .then(() => {
                    this.$router.push('/')
                    this.to = false;
                    this.username = null;
                    this.usermail = null;
                    this.$store.commit('change', {
                        user: false
                    });
                    return this.$eventBus.$emit('authState', 'signedOut')
                })
                .catch(e => this.setError(e));
        },
        setError: function(e) {
            this.error = this.$Amplify.I18n.get(e.message || e);
        },
    }
}
